(ns splash.ui.lender-portal.components.layout
  (:require
    [splash.ui.lender-portal.components.mui :as mui]
    [splash.ui.lender-portal.components.nav-bar :as nav-bar]
    [splash.ui.lender-portal.components.theme :as theme]))

(defn container
  [sidebar contents]
  [mui/box {:sx {:display "flex"
                 :width "100%"}}
   [mui/box {:sx {:flex 0}}
    sidebar]
   [mui/box {:sx {:flex 1}}
    contents]])

(defn default
  [content]
  [mui/theme-provider (mui/create-theme theme/theme)
   [mui/container {:id             "lender-portal-top-level"
                   :maxWidth       false
                   :disableGutters true
                   :sx             {:height          "100vh"
                                    :display         "flex"
                                    :flexDirection   "column"
                                    :backgroundColor theme/catskill-white}}
    [nav-bar/app->header]
    [mui/grid {:container true
               :style     {:flex-grow 1}
               :sx        {:justify-content "center"}} content]]])
